import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { makeSelectSubnavTopics } from 'data/subnav/subnav-selectors';
import { makeSelectDictionary, makeSelectBasePath } from 'data/config/runtime-config-selectors';
import Subnav from './subnav';

const mapStateToProps = createStructuredSelector({
    topics: makeSelectSubnavTopics(),
    dictionary: makeSelectDictionary(),
    itemsBasePath: makeSelectBasePath()
});

export default connect(mapStateToProps)(Subnav);
